// Shared by the React application and the pre-render theme bootstrap.
import presets from "./themePresets.json";
export const THEMES = presets;

export const resolveTheme = (id) => THEMES.find((theme) => theme.id === id) || THEMES[0];
export const isDarkTheme = (id) => resolveTheme(id).mode === "dark";
